import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  segments: [],
  selectedItem: null, // Currently selected item
  selectedType: null, // Type of the selected item (e.g., 'images', 'videos', etc.)
  selectedSegment: null, // Title of the selected segment
  isPreviewOpen: false, // Tracks if the preview modal is open
  selectedSegmentId: null,
};

const hotbarSlice = createSlice({
  name: 'hotbar',
  initialState,
  reducers: {
    setSegmentItems: (state, action) => {
      state.segments = action.payload;
    },
    setSelectedItem: (state, action) => {
      const { title, type, item, segmentId } = action.payload;
      state.selectedSegment = title;
      state.selectedType = type;
      state.selectedItem = item;
      state.isPreviewOpen = true;
      state.selectedSegmentId = segmentId;
    },
    setSelectedSegment: (state, action) => {
      const { segmentId } = action.payload;
      state.selectedSegmentId = segmentId;
    },
    clearSelectedItem: (state) => {
      state.selectedItem = null;
      state.selectedType = null;
      state.selectedSegment = null;
    },
    togglePreviewModal: (state) => {
      state.isPreviewOpen = !state.isPreviewOpen;
    },
    closePreviewModal: (state) => {
      state.isPreviewOpen = false;
      state.selectedItem = null;
      state.selectedType = null;
      state.selectedSegment = null;
    },
  },
});

export const {
  setSegmentItems,
  setSelectedItem,
  togglePreviewModal,
  closePreviewModal,
  clearSelectedItem,
  setSelectedSegment,
} = hotbarSlice.actions;

export default hotbarSlice.reducer;
